<template>
  <div
    class="w-auto flex items-center rounded-md overflow-hidden border border-[#D0D5DD]"
  >
    <ViewButton
      :clickFunction="clickFunction"
      :exisingView="view"
      :view="views.MAP"
    >
      <MapIcon />
    </ViewButton>
    <ViewButton
      :clickFunction="clickFunction"
      :exisingView="view"
      :view="views.LIST"
    >
      <ListIcon />
    </ViewButton>
  </div>
</template>

<script>
import ListIcon from "./ListIcon.vue";
import MapIcon from "./MapIcon.vue";
import ViewButton from "./ViewButton.vue";
export default {
  props: ["clickFunction", "view", "views"],
  components: {
    ListIcon,
    MapIcon,
    ViewButton,
  },
};
</script>

<style>
</style>